// Central content & brand data for Trinity Musical School landing page

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_prescrizioni-musica/artifacts/l4t1v05j_Logo%20TRINITY%20MUSICAL%20SCHOOL%20piccolo.png";

export const CONTACTS = {
  whatsappNumber: "393913084761",
  email: "info@trinitymusicalschool.net",
  centre: "71607",
  orari: "Lun–Ven 15:00–20:00 · Sab 10:00–13:00",
  phones: [
    { label: "Provincia di Ferrara", display: "0532 1716892", link: "+3905321716892" },
    { label: "Provincia di Rovigo", display: "0425 1666483", link: "+3904251666483" },
  ],
  mobiles: [
    { display: "391 396 5824", link: "+393913965824" },
    { display: "391 308 4761", link: "+393913084761" },
  ],
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACTS.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const PROMO = {
  schoolYear: "2026 / 2027",
  startLabel: "3 settembre 2026",
};

export const VIDEO_URL = "/videos/reel.mp4";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1612016410921-264f6afed556?w=1600&q=80&auto=format&fit=crop",
  concert:
    "https://images.unsplash.com/photo-1759502418465-62fb7c781e73?w=1200&q=80&auto=format&fit=crop",
};

export const SEDI = [
  {
    name: "Riva del Po",
    detail: "Piazza Mazzini 14 — località Ro (FE)",
    tag: "Sede principale · unica con Organo",
  },
  {
    name: "Polesella",
    detail: "Piazza Matteotti 112 (RO)",
    tag: "Strumenti moderni e canto",
  },
  {
    name: "Rovigo",
    detail: "Via Luigi Einaudi 16 — Area Tosi (RO)",
    tag: "Musica, canto e teatro",
  },
];

export const SEDI_NAMES = SEDI.map((s) => s.name);

export const COURSES = [
  {
    key: "pianoforte",
    title: "Pianoforte",
    tag: "Tastiere",
    desc: "Classico, moderno, jazz, pop & rock. Lezioni individuali con preparazione ai grade Trinity.",
    img: "https://images.unsplash.com/photo-1552422530-9b41dc72286b?w=1000&q=80&auto=format&fit=crop",
    span: "md:col-span-8 md:row-span-2",
    h: "h-[420px] md:h-full",
  },
  {
    key: "organo",
    title: "Organo",
    tag: "Unico in provincia",
    desc: "L'unico corso di Organo fuori dal Conservatorio, classico e liturgico.",
    img: "https://images.unsplash.com/photo-1723366647759-a368dda195d8?w=1000&q=80&auto=format&fit=crop",
    span: "md:col-span-4 md:row-span-1",
    h: "h-[280px]",
    highlight: true,
  },
  {
    key: "canto",
    title: "Canto Lirico & Moderno",
    tag: "Voce",
    desc: "Tradizione belcantistica e tecnica pop/rock. Preparazione Trinity Rock & Pop Vocals.",
    img: "https://images.unsplash.com/photo-1517230878791-4d28214057c2?w=1000&q=80&auto=format&fit=crop",
    span: "md:col-span-4 md:row-span-1",
    h: "h-[280px]",
  },
  {
    key: "violino",
    title: "Violino",
    tag: "Archi",
    desc: "Tecnica classica dal barocco al contemporaneo, musica da camera e orchestra.",
    img: "https://images.unsplash.com/photo-1692552951845-cb7762a29638?w=1000&q=80&auto=format&fit=crop",
    span: "md:col-span-4 md:row-span-1",
    h: "h-[280px]",
  },
  {
    key: "chitarra",
    title: "Chitarra",
    tag: "Corde",
    desc: "Classica e acustica: fingerstyle, accompagnamento, repertorio pop e folk.",
    img: "https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=1000&q=80&auto=format&fit=crop",
    span: "md:col-span-4 md:row-span-1",
    h: "h-[280px]",
  },
  {
    key: "teatro",
    title: "Teatro & Musical",
    tag: "Spettacolo",
    desc: "Recitazione, musical e arti performative. Dal primo accordo al palcoscenico.",
    img: "https://images.unsplash.com/photo-1514306191717-452ec28c7814?w=1000&q=80&auto=format&fit=crop",
    span: "md:col-span-4 md:row-span-1",
    h: "h-[280px]",
  },
];

export const COURSE_CATALOG = [
  {
    category: "Strumenti a tastiera",
    icon: "Piano",
    items: ["Pianoforte", "Tastiere Pop", "Organo"],
  },
  {
    category: "Canto",
    icon: "Mic2",
    items: ["Canto Lirico", "Canto Moderno"],
  },
  {
    category: "Strumenti a corda",
    icon: "Guitar",
    items: [
      "Violino",
      "Chitarra Classica",
      "Chitarra Acustica",
      "Chitarra Elettrica",
      "Basso Elettrico",
    ],
  },
  {
    category: "Fiati",
    icon: "Wind",
    items: ["Clarinetto", "Sassofono", "Flauto Traverso", "Tromba", "Trombone", "Eufonio"],
  },
  {
    category: "Percussioni",
    icon: "Drum",
    items: ["Batteria"],
  },
  {
    category: "Cori",
    icon: "Users",
    items: ["Coro Polifonico Amici per la Musica", "Coro di Voci Bianche LUCINCANTO"],
  },
  {
    category: "Bambini",
    icon: "Baby",
    items: ["Propedeutica Musicale (Baby Music 3-5 · Pre-Corso 6-7)"],
  },
  {
    category: "Performing Arts",
    icon: "Drama",
    items: ["Laboratorio di Teatro"],
  },
  {
    category: "Ensemble & Produzione",
    icon: "SlidersHorizontal",
    items: ["Musica d'Insieme", "Produzione Musicale"],
  },
];

export const COURSE_OPTIONS = [
  "Pianoforte",
  "Tastiere Pop",
  "Organo",
  "Canto Lirico",
  "Canto Moderno",
  "Violino",
  "Chitarra Classica",
  "Chitarra Acustica",
  "Chitarra Elettrica",
  "Basso Elettrico",
  "Clarinetto",
  "Sassofono",
  "Flauto Traverso",
  "Tromba",
  "Trombone",
  "Eufonio",
  "Batteria",
  "Coro Polifonico",
  "Coro di Voci Bianche",
  "Propedeutica Musicale",
  "Laboratorio di Teatro",
  "Musica d'Insieme",
  "Produzione Musicale",
  "Non so ancora, chiedo consiglio",
];

export const WHY = [
  {
    icon: "Award",
    title: "Certificazioni Trinity College London",
    desc: "Centro esami ufficiale n° 71607. Gli unici in provincia di Ferrara e Rovigo: grade riconosciuti a livello internazionale.",
  },
  {
    icon: "Piano",
    title: "Organo: unici nel territorio",
    desc: "L'unico corso di Organo in provincia fuori dal Conservatorio, sia classico che liturgico.",
  },
  {
    icon: "Receipt",
    title: "Quote detraibili nel 730",
    desc: "Un'agevolazione fiscale reale sulle quote, con copertura assicurativa inclusa per tutto l'anno.",
  },
  {
    icon: "BadgeCheck",
    title: "Doppio accreditamento regionale",
    desc: "APS iscritta al RUNTS, accreditata dalle Regioni Emilia-Romagna e Veneto.",
  },
  {
    icon: "HeartHandshake",
    title: "Percorsi per BES e disabilità",
    desc: "Personale specializzato e percorsi personalizzati, per un ecosistema davvero inclusivo.",
  },
  {
    icon: "Theater",
    title: "Dal primo accordo al palcoscenico",
    desc: "Concerti, contest ed esibizioni pubbliche reali: il palco è parte del metodo, non un optional.",
  },
];

export const STEPS = [
  {
    n: "01",
    title: "Contattaci",
    desc: "Scrivici su WhatsApp, via email o compila il modulo. Ti rispondiamo in poche ore, senza burocrazia.",
  },
  {
    n: "02",
    title: "Prima lezione conoscitiva gratuita",
    desc: "Fissiamo una prova senza impegno: conosci l'insegnante, vedi gli spazi e scegli la sede più comoda.",
  },
  {
    n: "03",
    title: "Inizio lezioni: 3 settembre",
    desc: "Scegli il format e parti con il tuo percorso personalizzato, fino all'esame Trinity se lo desideri.",
  },
];

export const FAQ = [
  {
    q: "Quando iniziano le lezioni?",
    a: "Le lezioni del nuovo anno scolastico 2026/2027 iniziano il 3 settembre 2026. Le iscrizioni sono aperte: contattaci per informazioni e disponibilità nelle tre sedi.",
  },
  {
    q: "Come mi iscrivo ai corsi?",
    a: "È semplice: contattaci via WhatsApp, email o compilando il modulo di richiesta informazioni. Ti ricontattiamo per fissare la prima lezione conoscitiva gratuita e definire il percorso più adatto.",
  },
  {
    q: "Mio figlio non ha mai suonato. Si parte da zero?",
    a: "Assolutamente sì. La maggior parte degli studenti inizia senza esperienza. Il percorso è costruito su misura a partire dalla prima lezione conoscitiva.",
  },
  {
    q: "Le certificazioni Trinity sono davvero riconosciute?",
    a: "Sì. Trinity College London è riconosciuto a livello internazionale. Le certificazioni valgono per accademie, crediti scolastici e curriculum. Siamo centro esami ufficiale n° 71607.",
  },
  {
    q: "Quali sedi avete?",
    a: "Tre sedi: Riva del Po (principale, unica con Organo), Polesella e Rovigo. Ti aiutiamo a scegliere quella più comoda in base allo strumento e agli orari.",
  },
  {
    q: "Le quote sono detraibili?",
    a: "Sì, le quote sono detraibili nel 730. La quota di iscrizione annuale include inoltre la copertura assicurativa per tutto l'anno scolastico.",
  },
];
